<template>
    <div class="d-flex align-center">
        <span v-if="prependText" class="me-2">
            {{ prependText }}
        </span>
        <v-number-input
            v-model="modelValue"
            :min="0"
            hide-details="auto"
            :label="label"
            class="flex-grow-0 flex-shrink-0"
            :width="width"
            data-cy="value"
            :rules="rules"
            :readonly="readonly"
            :disabled="disabled"
        >
            <template v-slot:append-inner>
                <v-btn
                    v-for="(button, index) in useButtons"
                    :key="index"
                    size="x-small"
                    :color="button.active ? 'primary' : 'grey-lighten-1'"
                    class="cursor-pointer"
                    variant="text"
                    :icon="button.icon"
                    :data-cy="`change-on-${button.icon}`"
                    :readonly="readonly"
                    :disabled="disabled"
                    @click="button.onClick"
                />
            </template>
        </v-number-input>
        <span v-if="appendText" class="ms-2">
            {{ appendText }}
        </span>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        label: string
        prependText?: string
        appendText?: string
        width: number
        buttons: Array<{icon: string; active: boolean; onClick: () => void}>
        rules?: Array<((value: any) => true | string) | string>
        readonly?: boolean
        disabled?: boolean
        hideDetails?: boolean | 'auto'
    }>()

    const modelValue = defineModel<number>()

    const useButtons = computed(() => {
        return props.buttons.filter(button => button)
    })
</script>
